import gql from 'graphql-tag'

export const SUBSCRIBE_ALL_ORGANIZATION = gql`
    subscription ($partnerType:[uuid!],$prefferedVP:uuid!){
        Organizations(where:{status:{_eq: "Active"},partnerType:{_nin:$partnerType},
            PreferredDistributors: {prefferedDistributorId: {_eq: $prefferedVP}}}){
            id
            name
            Inventory: BatchTable_aggregate(where: {status:{_eq:"InStock"}}) {
                aggregate {
                    count
                }
            }
            Application{id name incorporateDate userBirthdate userAniversary}
            Users {id name}
            partnerType
            PartnerType {id name color prefix specialSchemeId }
            SchemePoints {id earnPoint eligiblePoint myTeamEligiblePoint myTeamEarnPoint schemeId}
            PreferredDistributors (order_by: {PrefferedPartner: {name: asc}}) {id prefferedDistributorId PrefferedPartner{id name mobile email partnerCode}}
            partnerCode
            name
            status
            address
            mobile
            email
            gstin
            aadhaarNumber
            PAN
            bankDetails
            products
            partnerCode
            referralCode
            parentPartnerId
            createdOn
            SalesPersons (order_by: {SalesPerson: {name: asc}}) {id SalesPerson{name mobile email id}}
            ParentPartner{id name}
            PreferedVP{id name}
        }
    }
`

export const SUBSCRIBE_ALL_ORGANIZATIONS_COUNT = gql`
    subscription ($partnerType:[uuid!],$prefferedVP:uuid!){
        Organizations(where:{status:{_eq: "Active"},partnerType:{_nin:$partnerType},
            PreferredDistributors: {prefferedDistributorId: {_eq: $prefferedVP}}}){
            partnerType
        }
    }
`
export const SUBSCRIBE_ORG_BY_ID = gql`
    subscription ($id:uuid!){
        Organizations(where:{status:{_eq: "Active"},id:{_eq:$id}}){
            id
            partnerType
            PartnerType {id name color prefix }
            ParentPartner{id name mobile email partnerCode}
            PreferedVP{id name mobile email partnerCode}
            SalesPersons {id SalesPerson{name mobile email id}}
            PreferredDistributors {id prefferedDistributorId PrefferedPartner{id name mobile email partnerCode}}
            name
            status
            address
            mobile
            alternateNumber
            email
            PAN
            gstin
            aadhaarNumber
            incorporateDate
            partnerCode
            bankDetails
            products
            referralCode
            parentPartnerId
            createdOn
            documents
        }
    }
`
